import React from "react";


const SelectFilter: React.FC<{ label?: string, selectOptions: string[], selected: string, onFilter: (text: string) => void, onClear: () => void }> = ({ label, selectOptions, selected, onFilter, onClear }) => {

    return (
        <div className="flex flex-col gap-1 items-start">
            {label && <label className="text-xs font-semibold text-gray-600 ml-1">{label}</label>}
            <select
                value={selected}
                onChange={(e) => onFilter(e.target.value)}
                className="border border-gray-300 p-2 rounded-lg w-64 text-sm"
            >
                <option value="">Seleccionar...</option>
                {selectOptions.map((option, index) => (
                    <option key={index} value={option}>{option}</option>
                ))}
            </select>
        </div>
    );
}

export default SelectFilter;